import React from 'react';
import { Meteor } from 'meteor/meteor';
import { Reservations } from '../../collections/reservations/reservations';
import moment from 'moment';
import { reservationsExport, reservationsCancelExport } from '../../collections/statistics/reservations';

const Papa = require('papaparse');
const FileSaver = require('file-saver');
const utf8 = require('utf8');

import {
	Row,
	Col,
	Grid,
	Panel,
	PanelBody,
	PanelContainer,
	Button,
	ButtonToolbar,
  FormGroup,
  ControlLabel,
  FormControl
} from '@sketchpixy/rubix';

import { Reactive } from '../common/Reactive.mixin.js';
import { PanelHeader } from '@sketchpixy/rubix/lib/Panel';

@Reactive({
	subscriptions: ['users']
})
export default class ExportsPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			'nbYears': moment().diff(moment().year(2016), 'years') + 1,
			'selectedYear': '2016'
		};


	}

	selectYear(ref) {
		let year = ref.target.value;
		this.setState({
			'selectedYear': year
		});
	}

	downloadFile(file, name) {

		var csvData = new Blob(["\uFEFF"+file], {
		type: 'text/csv; charset=utf-18'
		});
		var csvURL = window.URL.createObjectURL(csvData);
		var tempLink = document.createElement('a');
		tempLink.href = csvURL;
		tempLink.setAttribute('download', name + '.csv');
		tempLink.click();
	}

	exportAll() {
		this.setState({'pendingAll': true});
		reservationsExport.call({ 'selectedYear': this.state.selectedYear
			}, ((err, results) => {
				this.setState({'pendingAll': false});
				let file = Papa.unparse(results, {delimiter: ";"});
				this.downloadFile(file, 'reservations.csv');
			}).bind(this));

	}

	exportCancelAll() {
		this.setState({'pendingCancelAll': true});
		reservationsCancelExport.call({ 'selectedYear': this.state.selectedYear
			}, ((err, results) => {
				this.setState({'pendingCancelAll': false});
				let file = Papa.unparse(results, {delimiter: ";"});
				this.downloadFile(file, 'reservations-annulee.csv');
			}).bind(this));
	}

	createOptions() {
		let options = []

    // Outer loop to create parent
    for (let i = 0; i <= this.state.nbYears; i++) {

      //Create the parent and add the children
      options.push(<option value={(2016 + i)}>{(2016 + i)}</option>)
    }
    return options;
	}

	getPartners() {
		let partners = [];

		Meteor.users.find({roles:{$in:['partner']}}).map((partner) => {
			partners.push(<option value={partner._id}>{partner.profile.firstName} {partner.profile.lastName}</option>);
		});

		return partners;
	}

	render() {
		return (
			<div>
				<PanelContainer>
					<Panel>
						<PanelHeader className='bg-blue'>
							<Grid>
							<Row>
								<Col xs={12} className='fg-white'>
									<h3>Réservations</h3>
								</Col>
							</Row>
							</Grid>
						</PanelHeader>
						<PanelBody style={{padding: 20, paddingBottom: 25}}>
								Année séléctionnée :
								<FormControl componentClass="select" placeholder="select" ref="year" onChange={this.selectYear.bind(this)}>
									{this.createOptions()}
								</FormControl>

								<hr/>

								{!this.state.pendingAll &&
				<Button bsStyle="primary" onClick={this.exportAll.bind(this)}>Réservations</Button>
								}
								{this.state.pendingAll &&
								<Button bsStyle="disabled">En cours...</Button>
								}
								<br/>
								<small>Retourne un fichier csv contenant les réservations</small><hr/>

								{!this.state.pendingCancelAll &&
				<Button bsStyle="primary" onClick={this.exportCancelAll.bind(this)}>Réservations annulée</Button>
								}
								{this.state.pendingCancelAll &&
								<Button bsStyle="disabled">En cours...</Button>
								}
								<br/>
								<small>Retourne un fichier csv contenant les réservations annulée</small><hr/>

						</PanelBody>
					</Panel>
				</PanelContainer>

				{/*<PanelContainer>
					<Panel>
						<PanelHeader className='bg-blue'>
							<Grid>
							<Row>
								<Col xs={12} className='fg-white'>
									<h3>Partenaires</h3>
								</Col>
							</Row>
							</Grid>
						</PanelHeader>
						<PanelBody style={{padding: 20, paddingBottom: 25}}>
							Partenaire :
							<FormControl componentClass="select" placeholder="select" ref="year" onChange={this.selectYear.bind(this)}>
								{this.getPartners()}
							</FormControl>
							Année séléctionnée :
							<FormControl componentClass="select" placeholder="select" ref="year" onChange={this.selectYear.bind(this)}>
								{this.createOptions()}
							</FormControl>
						</PanelBody>
					</Panel>
				</PanelContainer>*/}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/exports/Exports.page.js
 **/